

class TransformService {
  serializeAutomation(state) {
    return {
      name: state.wizardData.name,
      description: state.wizardData.description,
      trigger_object: state.wizardData.object,
      trigger_event: state.wizardData.trigger,
      trigger_conditions: this.serializeConditions(state.conditionGroups),
      group_logic: state.groupLogic,
      actions: this.serializeActions(state.actions),
      is_active: state.wizardData.isActive
    };
  }

  deserializeAutomation(automation) {
    return {
      wizardData: {
        name: automation.name || '',
        description: automation.description || '',
        object: automation.trigger_object || '',
        trigger: automation.trigger_event || '',
        isActive: automation.is_active !== false
      },
      conditionGroups: this.deserializeConditions(automation.trigger_conditions),
      groupLogic: automation.group_logic || 'AND',
      actions: this.deserializeActions(automation.actions)
    };
  }

  serializeConditions(conditionGroups) {
    return conditionGroups.map(group => ({
      ...group,
      conditions: group.conditions.map(condition => ({
        ...condition,
        value: this.serializeValue(condition.value)
      }))
    }));
  }

  deserializeConditions(conditions) {
    if (!conditions) return [];
    
    if (Array.isArray(conditions)) {
      return conditions.map((group, index) => ({
        id: group.id || `group_${index + 1}`,
        name: group.name || `Group ${index + 1}`,
        logic: group.logic || 'AND',
        logicMode: group.logicMode || 'simple',
        customLogic: group.customLogic || '',
        conditions: (group.conditions || []).map((condition, condIndex) => ({
          id: condition.id || `condition_${condIndex + 1}`,
          field: condition.field,
          operator: condition.operator,
          value: this.deserializeValue(condition.value)
        }))
      }));
    }
    
    return [];
  }

  serializeActions(actions) {
    return actions.map(action => ({
      ...action,
      parameters: this.serializeParameters(action.parameters)
    }));
  }

  deserializeActions(actions) {
    if (!actions) return [];
    
    return actions.map(action => ({
      ...action,
      parameters: this.deserializeParameters(action.parameters),
      timeDelay: action.timeDelay || {
        enabled: false,
        days: 0,
        hours: 0,
        minutes: 0
      }
    }));
  }

  serializeValue(value) {
    // Handle relative date values (signed amount + optional field anchor)
    if (typeof value === 'object' && value?.mode === 'relative') {
      const raw = Number(value.amount) || 0;
      const signed =
        value.direction === 'before' ? -Math.abs(raw) : Math.abs(raw);
      const unit = value.unit || 'days';
      const anchor =
        value.anchor && value.anchor !== 'trigger' ? `::${value.anchor}` : '';
      return `RELATIVE::${signed}::${unit}${anchor}`;
    }
    return value;
  }

  deserializeValue(value) {
    // Handle relative date values
    if (typeof value === 'string' && value.startsWith('RELATIVE::')) {
      const parts = value.split('::');
      if (parts.length >= 3) {
        const amount = parseInt(parts[1], 10) || 0;
        return {
          mode: 'relative',
          amount: Math.abs(amount),
          unit: parts[2] || 'days',
          direction: amount < 0 ? 'before' : 'after',
          anchor: parts[3] || 'trigger',
        };
      }
    }
    return value;
  }

  serializeParameters(parameters) {
    if (!parameters) return {};
    
    const serialized = {};
    Object.entries(parameters).forEach(([key, value]) => {
      serialized[key] = this.serializeValue(value);
    });
    return serialized;
  }

  deserializeParameters(parameters) {
    if (!parameters) return {};
    
    const deserialized = {};
    Object.entries(parameters).forEach(([key, value]) => {
      deserialized[key] = this.deserializeValue(value);
    });
    return deserialized;
  }
}

export default new TransformService();
